import React, { FC } from "react";
import { Row, Col } from "react-bootstrap";

import DataTable, { TableColumn, TableProps } from "react-data-table-component";
import { DATA_TABLE_DEFAULT_STYLE } from "../../constants";
import FlexBox from "./flex-box";
import LoadingBox from "./loading-box";

interface SimpleDataTableProps<T> extends TableProps<T> {
  title?: string;
  columns: TableColumn<T>[];
  action?: React.ReactNode;
  onRowClick?: (row: T) => void;
  error?: string | null;
  isLoading?: boolean;
  isShowPagination?: boolean;
}

const SimpleDataTable: FC<SimpleDataTableProps<unknown>> = ({
  title,
  columns,
  action,
  onRowClick,
  error,
  isLoading,
  isShowPagination = true,
  ...props
}) => {
  return (
    <>
      <FlexBox justifyContent="between" alignItems="center">
        {title && <h5 className="m-0 d-flex align-items-center">{title}</h5>}
        <>{action}</>
      </FlexBox>
      <Row className={title && "my-4"}>
        {error ? (
          <Col>
            <p className="text-danger">{error}</p>
          </Col>
        ) : (
          <Col>
            {isLoading ? (
              <LoadingBox message="Fetching data ..." />
            ) : (
              <DataTable
                columns={columns}
                highlightOnHover
                customStyles={DATA_TABLE_DEFAULT_STYLE}
                pagination={isShowPagination}
                onRowClicked={onRowClick}
                fixedHeaderScrollHeight="auto"
                responsive
                {...props}
              />
            )}
          </Col>
        )}
      </Row>
    </>
  );
};

export default SimpleDataTable;
